import { watchChannels } from "@/mocks/content";

export default function WatchGuide() {
  return (
    <section id="guide" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-accent-700">
            <i className="ri-guide-line"></i>
            观看指南
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            网页版入口、手机在线看与在线播放
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-700">
            不同观看方式的体验差别不小，先弄清各自适合的场景，再决定用哪种方式追剧，会顺很多。
            下面把常见三种方式的特点、适用场景和注意点分别整理出来。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 lg:grid-cols-3">
          {watchChannels.map((channel, index) => (
            <div
              key={channel.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-md ${
                  index === 0
                    ? "bg-primary-100 text-primary-700"
                    : index === 1
                      ? "bg-accent-100 text-accent-700"
                      : "bg-secondary-100 text-secondary-900"
                }`}
              >
                <i className={`${channel.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{channel.title}</h3>
              <p className="mt-1 text-xs font-medium text-primary-600">{channel.subtitle}</p>
              <p className="mt-3 flex-1 text-sm leading-6 text-foreground-700">{channel.desc}</p>
              <ul className="mt-4 space-y-2 border-t border-background-200 pt-4">
                {channel.points.map((point) => (
                  <li key={point} className="flex items-center gap-2 text-sm text-foreground-800">
                    <i className="ri-check-line text-secondary-600"></i>
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 grid items-stretch gap-5 lg:grid-cols-5">
          <div className="relative h-64 w-full overflow-hidden rounded-lg bg-background-200 lg:col-span-3 lg:h-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20evening%20scene%20of%20a%20person%20relaxing%20on%20a%20sofa%20watching%20a%20drama%20on%20a%20laptop%20with%20warm%20string%20lights%20and%20a%20cup%20of%20tea%2C%20warm%20amber%20and%20coral%20tones%2C%20soft%20ambient%20lighting%2C%20minimal%20tidy%20interior%2C%20editorial%20photography%20style%2C%20high%20detail&width=1200&height=800&seq=hdrama-guide-01&orientation=landscape"
              alt="在电脑前在线观看韩剧的居家场景"
              title="韩剧TV 网页版入口在线播放"
              className="h-full w-full object-top"
            />
          </div>
          <div className="flex flex-col justify-center rounded-lg border border-background-200 bg-background-50 p-6 lg:col-span-2">
            <h3 className="font-heading text-lg font-bold text-foreground-950">选择渠道前，先确认这几件事</h3>
            <ul className="mt-4 space-y-3">
              <li className="flex gap-3">
                <i className="ri-shield-check-line mt-0.5 text-lg text-primary-600"></i>
                <p className="text-sm leading-6 text-foreground-700">
                  <strong className="font-semibold text-foreground-950">来源是否正规：</strong>
                  优先选择有正规授权的渠道，内容与账号信息更有保障。
                </p>
              </li>
              <li className="flex gap-3">
                <i className="ri-device-line mt-0.5 text-lg text-accent-700"></i>
                <p className="text-sm leading-6 text-foreground-700">
                  <strong className="font-semibold text-foreground-950">设备是否匹配：</strong>
                  电脑更适合大屏长时段观看，手机则方便随时接续进度。
                </p>
              </li>
              <li className="flex gap-3">
                <i className="ri-speed-line mt-0.5 text-lg text-secondary-700"></i>
                <p className="text-sm leading-6 text-foreground-700">
                  <strong className="font-semibold text-foreground-950">播放是否稳定：</strong>
                  留意清晰度选项与加载速度，避免追到一半频繁卡顿。
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}